export default "__VITE_ASSET__nBS$dxGG__"